module.exports = __webpack_public_path__ + "img/criminal_person.c6e0c89f.png";